import * as PROJECT_CODE from '../../constants/projectCode';
import { ClearThisClientDocumentInfo } from '../../api/Clients/clearClientDocumentInfo.api';
import firebase from '../../lib/firebase.prod';

export async function SetClientToNotVisible(thisClientEmail, clientJson) {
	try {
		var currentUserId = clientJson.salesAgentId;

		var thisSalesAgentPointer;

		await firebase
			.database()
			.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
			.orderByChild('createrID')
			.equalTo(currentUserId)
			.limitToFirst(1)
			.once('value', (snapshot) => {
				var snapData = snapshot.val();

				console.log('SnapData ', snapData);

				var allKeys = Object.keys(snapData);

				//var keyToCall = snapData[allKeys[0]];

				thisSalesAgentPointer = allKeys[0];

				console.log('saveOrUpdateDocument key', thisSalesAgentPointer);
			});

		var clientPointer;

		console.log('this client email ', thisClientEmail);

		await firebase
			.database()
			.ref(
				'kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					thisSalesAgentPointer +
					'/myClients'
			)
			.orderByChild('clientEmail')
			.equalTo(thisClientEmail)
			.limitToFirst(1)
			.once('value', (snapshot) => {
				var snapData = snapshot.val();

				console.log('SnapData ', snapData);

				var allKeys = snapData && Object.keys(snapData);

				//var keyToCall = snapData[allKeys[0]];

				clientPointer = allKeys[0];

				console.log('clientPointer key', clientPointer);
			});

		var toSet = { showClient: false };

		await firebase
			.database()
			.ref(
				'kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					thisSalesAgentPointer +
					'/myClients/' +
					clientPointer
			)
			.update(toSet);

		console.log('SetClientToNotVisible client: ', clientJson);

		ClearThisClientDocumentInfo(clientJson, PROJECT_CODE.projectCode);
	} catch (error) {
		console.error(error);
	}
}
